/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
import type { TranslationKey } from '../models/TranslationKey';

export type DefaultTranslations = Record<keyof typeof TranslationKey, string>;

export const defaultTranslations: DefaultTranslations = {
  basket: 'basket',
  copy: 'Copy',
  copyLink: 'Copy Link',
  emptyBag: 'Empty bag',
  emptyBagMessage: 'Looking pretty empty in your bag',
  goToBasket: 'Go to basket',
  linkCopied: 'Link copied!',
  qty: 'qty',
  shareWithBrandPartner: 'Share basket with brand partner',
  shareYourBasket: 'share your basket',
  superdeal: 'superdeal',
};

export const translationsNamespace = 'mini-shopping-bag';
